export enum SegmentationType {
    INSTANCEANDSEMANTIC = 'InstanceAndSemantic',
    INSTANCE = 'Instance',
    SEMANTIC = 'Semantic',
}
